import React from 'react';

import { Suspense, useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { firebase_app } from '../data/config';

import { configureFakeBackend, authHeader, handleResponse } from '../services/fack.backend';
import Callback from '../auth/callback';
import Loader from '../layout/loader';
import { authRoutes } from './AuthRoutes';
import LayoutRoutes from './LayoutRoutes';
import Signin from '../auth/signin';
import PrivateRoute from './PrivateRoute';
import { classes } from '../data/layouts';
import Register from '../pages/authentication/register';

// setup fake backend
configureFakeBackend();
const Routers = () => {

        const jwt_token = localStorage.getItem('token');
        const defaultLayoutObj = classes.find(item => Object.values(item).pop(1) === 'compact-wrapper');
        const layout = localStorage.getItem('layout') || Object.keys(defaultLayoutObj).pop();


        return (
                <BrowserRouter basename={'/'}>
                        <>
                                <Suspense fallback={<Loader />}>
                                        <Routes>
                                                <Route path={'/'} element={<PrivateRoute />}>
                                                        {jwt_token ?
                                                                <>
                                                                        <Route exact
                                                                                path={`${process.env.PUBLIC_URL}` }
                                                                                element={<Navigate to={`/app/users/userTable/${layout}`} />}
                                                                        />
                                                                </> : ''}
                                                        <Route path={`/*`} element={<LayoutRoutes />} />
                                                </Route>
                                                <Route exact path={`/login`} element={<Signin />} />
                                                {authRoutes.map(({ path, Component }, i) => (
                                                        <Route path={path} element={Component} key={i} />
                                                ))}
                                        </Routes>
                                </Suspense>
                        </>
                </BrowserRouter>
        );
};

export default Routers;